import {
  Container,
  createStyles,
  makeStyles,
  Toolbar
} from '@material-ui/core';
import { BtcsDrawer } from 'components/base/BtcsDrawer';
import { BtcsHeader } from 'components/base/BtcsHeader';
import { DrawerContextProvider } from 'contexts/DrawerContext';
import { memo } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Vote } from 'views/ClientDestination/Vote';
import { Reject } from 'views/Transaction/Reject';

const useStyles = makeStyles(() => createStyles({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    overflow: 'auto'
  }
}));

export const App = memo(() => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <DrawerContextProvider>
        <BtcsHeader />
        <BtcsDrawer />
        <main className={classes.content}>
          <Container>
            <Toolbar />
            <Switch>
              {/* query param cdvNotificationId */}
              <Route path={['/ClientDestination/Vote', '/api/ClientDestinationVersion/Vote']} render={() => <Vote />} />

              {/* query param transactionId */}
              <Route path={['/Transaction/Reject', '/api/Transaction/Reject']} render={() => <Reject />} />
              <Route path={['/']} render={() => <></>} />
            </Switch>
          </Container>
        </main>
      </DrawerContextProvider>
    </div>
  );
});
